import React, { useCallback, useEffect, useState } from "react";
import {
  styled,
  Grid,
  SvgIcon,
  Tab,
  Tabs,
  Typography,
  useTheme,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const StyledTabList = styled(Tabs)(({ theme }) => [
  {
    "& .MuiTabs-list": {
      padding: "4px",
      border: `1px solid ${theme.branding.gray[200]}`,
      borderRadius: "10px",
      backgroundColor: theme.branding.gray[100],
    },
    "& .MuiTabs-scroller": {
      maxWidth: "fit-content",
    },
    "& .MuiTab-root": {
      minHeight: "auto",
      zIndex: 2,
    },
    "& .Mui-selected": {
      color: `${theme.branding.gray[0]} !important`,
      transition: `opacity ${theme.transitions.duration.standard}`,
    },
    "& .MuiTabs-indicator": {
      height: "calc(100% - 8px)",
      bottom: "4px",
      borderRadius: "8px",
      background: `linear-gradient(90deg, ${theme.branding.cyan[300]} 0%, ${theme.branding.cyan[600]} 100%)`,
      zIndex: 1,
      transition: theme.transitions.create(["left", "width"], {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeInOut,
      }),
    },
  },
  theme.applyStyles("dark", {
    padding: "4px",
    border: `1px solid ${theme.branding.darkBlue[600]}`,
    borderRadius: "10px",
    backgroundColor: theme.branding.darkBlue[800],
  }),
]);

const TabSwitch = (props) => {
  //NOTE: Parent must be wrapped in TabContext from @mui/lab, and use TabPanel to display child component
  const { tabs, currTab, handleTabChange, context } = props;
  const theme = useTheme();
  const [value, setValue] = useState(currTab || "");

  const handleChange = useCallback(
    (event, newTab) => {
      handleTabChange(event, newTab);
      setValue(newTab);
    },
    [handleTabChange],
  );

  useEffect(() => {
    value !== currTab && handleChange(undefined, currTab);
  }, [currTab, value, handleChange]);

  return (
    <StyledTabList
      value={value}
      onChange={(e, value) => handleChange(e, value)}
      aria-label="contest picks stage view tab"
    >
      {tabs.map((tab) => (
        <Tab
          key={`${context}-tab-${tab.value}`}
          value={tab.value}
          disabled={tab.disabled}
          disableRipple
          label={
            <Grid
              container
              direction="row"
              wrap="nowrap"
              sx={{
                gap: "4px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 500,
                  color: tab.disabled ? theme.branding.gray[400] : "inherit",
                }}
              >
                {tab.label}
              </Typography>
              {tab.disabled && (
                <SvgIcon
                  component={LockOutlinedIcon}
                  sx={{
                    width: "14px",
                    height: "14px",
                    color: tab.disabled ? theme.branding.gray[400] : "inherit",
                  }}
                />
              )}
            </Grid>
          }
        />
      ))}
    </StyledTabList>
  );
};

export default TabSwitch;
